import { computed, ref } from "vue";

/*********************************************************************/
//                       NON-REACTIVE CONSTANTS                      //
/*********************************************************************/
import { createDefaultLogger } from "@/types/console-logger";
const logger = createDefaultLogger();

// The following tracks the free-form text input by the user to filter down the list of content
const textSearchFilter = ref< string >( '' );

/*********************************************************************/
//                      INSTANCE SPECIFIC STATE
/*********************************************************************/
export function useTextFilter() {
    // Status filters
    const hasSearchValue = computed< boolean >( (): boolean => textSearchFilter.value.trim().length > 0 );

    function filterOutItemsThatDoNotContainSearchText( textContent: ( string | null | undefined )[] ): boolean {
        logger.debug( `[ text-filter ].filterOutItemsThatDoNotContainSearchText -> searchText : '${ textSearchFilter.value }'` );
        const caseInsensitiveTextFilter = textSearchFilter.value.toLocaleLowerCase();
        return textContent.some( ( text: ( string | null | undefined ) ) => !!text && text.toLocaleLowerCase().includes( caseInsensitiveTextFilter ) );
    }

    // Event handler that clears the search text field
    function resetSearchText() {
        textSearchFilter.value = '';
    }

    return {
        filterOutItemsThatDoNotContainSearchText,
        resetSearchText,
        hasSearchValue,
        textSearchFilter
    }
}
